var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMikrofon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 36,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3855 22.875C20.1607 22.875 22.4105 20.6924 22.4105 18V9.875C22.4105 7.18258 20.1607 5 17.3855 5C14.6102 5 12.3604 7.18258 12.3604 9.875V18C12.3604 20.6924 14.6102 22.875 17.3855 22.875ZM25.7605 14.75H24.923C24.4603 14.75 24.0855 15.1136 24.0855 15.5625V18C24.0855 21.7984 20.7098 24.8463 16.716 24.4685C13.2351 24.1389 10.6854 21.1032 10.6854 17.7105V15.5625C10.6854 15.1136 10.3106 14.75 9.84787 14.75H9.01036C8.54764 14.75 8.17285 15.1136 8.17285 15.5625V17.6019C8.17285 22.1539 11.5213 26.2118 16.1292 26.8283V28.5625H13.1979C12.7352 28.5625 12.3604 28.9261 12.3604 29.375V30.1875C12.3604 30.6364 12.7352 31 13.1979 31H21.573C22.0357 31 22.4105 30.6364 22.4105 30.1875V29.375C22.4105 28.9261 22.0357 28.5625 21.573 28.5625H18.6417V26.8476C23.1281 26.2504 26.598 22.5145 26.598 18V15.5625C26.598 15.1136 26.2233 14.75 25.7605 14.75Z",
    fill: "url(#paint0_linear_11_1533)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_1533",
    x1: 33.0232,
    y1: 26.2583,
    x2: 22.2281,
    y2: 35.5044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikrofon);
export default __webpack_public_path__ + "static/media/mikrofon.72a9977b786f79245265476329998e7e.svg";
export { ForwardRef as ReactComponent };